import { useState, useEffect } from "react";
import axios from "axios";

//get either most recent shipments or filtered shipments with their corresponding order information
const useShipments = () => {
  const [shipments, setShipments] = useState(null); // Store shipment data
  const [orders, setOrders] = useState(null); // Store order data
  const [loadingShipments, setLoadingShipments] = useState(false); // Track loading state
  const [error, setError] = useState(null); // Track errors

  const fetchShipments = async (query) => {
    const startTime = Date.now(); // Record the start time
    setLoadingShipments(true); // Set loading to true when fetching begins
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("authToken");
      const response = await axios.get(`${apiUrl}/api/fetch_shipments/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          query: query, 
        },
      });
      const fetchedShipments = response.data.shipments || [];
      setShipments(fetchedShipments);
      const fetchedOrders = response.data.orders.data.orders.edges || [];
      setOrders(fetchedOrders);
      setError(null); // Clear any previous errors
    } catch (err) {
      console.error("Error fetching shipments:", err);
      setError(err);
    } finally {
      const elapsedTime = Date.now() - startTime; // Calculate elapsed time
      const timeOut = 4000; // Minimum loading time
      const remainingTime = Math.max(timeOut - elapsedTime, 0);
      setTimeout(() => setLoadingShipments(false), remainingTime); // smoothen UX
    }
  };
  return { shipments, orders, loadingShipments, error, fetchShipments };
};

export default useShipments;
